import React, { forwardRef, ReactNode } from 'react';
import {
  Accordion as AccordionUI,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import * as AccordionPrimitive from '@radix-ui/react-accordion';

interface AccordionProps {
  option: { trigger: ReactNode; content: ReactNode; value?: string }[];
  rootProps: React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Root>;
  itemProps?: React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>;
  triggerProps?: React.ComponentPropsWithoutRef<
    typeof AccordionPrimitive.Trigger
  >;
  contentProps?: React.ComponentPropsWithoutRef<
    typeof AccordionPrimitive.Content
  >;
}

const Accordion = forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  AccordionProps
>(({ option, rootProps, triggerProps, contentProps, itemProps }, ref) => {
  return (
    <AccordionUI ref={ref} {...rootProps}>
      {option.map(({ trigger, content, value }, idx) => {
        return (
          <AccordionItem
            value={value ?? idx.toString()}
            key={idx.toString()}
            {...itemProps}
          >
            <AccordionTrigger {...triggerProps}>{trigger}</AccordionTrigger>
            <AccordionContent {...contentProps}>{content}</AccordionContent>
          </AccordionItem>
        );
      })}
    </AccordionUI>
  );
});

export default Accordion;
